<template>
  <div class="page-content campus-list">
    <div class="header">
      <div class="searchBox ser">
        <a-auto-complete
          class="global-search"
          v-model="searchValue"
          style="width: 200px"
          placeholder="检索"
        />
      </div>
      <div class="btnBox ser">
        <a-button type="primary" @click="showModalAddList"> 添加基金 </a-button>
      </div>
    </div>
    <div class="navList">
      <a-tabs :default-active-key="switchData[0].id" @change="changeTab">
        <a-tab-pane v-for="item in switchData" :key="item.id" :tab="item.name">
          <a-table
            :loading="fundAllListLoading"
            :data-source="fundAllListData"
            :rowKey="(fundAllListData) => fundAllListData.id"
            :scroll="{ x: 1500 }"
            :pagination="{
              total: total,
              pageSize: pageSize,
              current: current,
              showTotal: (total) =>
                $t('public.page', { total: total, pageSize: pageSize }),
              onChange: currentChange,
            }"
          >
            <a-table-column
              :width="150"
              title="名称"
              :ellipsis="true"
              dataIndex="fundName"
            >
            </a-table-column>
            <a-table-column :ellipsis="true" title="网址" dataIndex="enrollUrl">
            </a-table-column>
            <a-table-column :ellipsis="true" title="概述" dataIndex="fundUnit">
            </a-table-column>
            <a-table-column
              :ellipsis="true"
              title="介绍"
              :width="300"
              dataIndex="enrollIntro"
            >
              <template slot-scope="enrollIntro">
                <div class="tableItem">
                  {{ enrollIntro }}
                </div>
              </template>
            </a-table-column>
            <a-table-column :ellipsis="true" title="封面" dataIndex="fundImg">
              <template slot-scope="fundImg">
                <div class="imgBox" style="width: 50px; height: 50px">
                  <img
                    style="width: 50px; height: 50px"
                    :src="fundImg"
                    alt=""
                  />
                </div>
              </template>
            </a-table-column>
            <!-- <a-table-column :width="150" title="申请条件" dataIndex="type">
              <template slot-scope="id, fundAllListData">
                <a @click="btnApplyDetail(fundAllListData.id)">查看详情</a>
              </template>
            </a-table-column>
            <a-table-column
              :width="150"
              fixed="right"
              title="帮助问答"
              dataIndex="QA"
            >
              <template slot-scope="id, fundAllListData">
                <a @click="btnSeeDetail(fundAllListData.fundName)">查看详情</a>
              </template>
            </a-table-column> -->
            <a-table-column :ellipsis="true" title="附件" dataIndex="fujian">
              <template slot-scope="fujian">
                <div>
                  <span @click="btnopenfile(fujian)"
                    ><a-icon
                      style="color: #4a9cd3; font-size: 18px"
                      type="file-pdf"
                  /></span>
                </div>
              </template>
            </a-table-column>
            <a-table-column
              :ellipsis="true"
              title="申请人数"
              dataIndex="count"
            >
              <template slot-scope="count">
                {{ count }}
              </template>
            </a-table-column>
            <a-table-column
              :ellipsis="true"
              title="申请详情"
              dataIndex="detail"
            >
              <template slot-scope="id, fundAllListData">
                <a @click="btnDetail(fundAllListData.id)">查看详情</a>
              </template>
            </a-table-column>
            <a-table-column
              :width="150"
              fixed="right"
              title="操作"
              dataIndex="operation"
            >
              <template slot-scope="id, fundAllListData">
                <a @click="() => btnEdit(fundAllListData.id)">编辑</a>
                <div class="border"></div>
                <a-popconfirm
                  title="确定删除?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="btnDelect(fundAllListData.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </template>
            </a-table-column>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>

    <a-modal
      width="800px"
      v-model="applyMode"
      title="申请条件"
      @ok="applyModelOk"
    >
      <div class="tableBox">
        <div class="header">
          <div class="ser">申请条件</div>
          <div class="ser">
            <a-button @click="btnAddApplyList" type="primary"> 添加 </a-button>
          </div>
        </div>
        <div class="content">
          <a-table
            :data-source="applyTableData"
            :pagination="{
              total: totalApplyList,
              pageSize: pageSizeApplyList,
              current: currentApplyList,
              showTotal: (total) =>
                $t('public.page', {
                  total: totalApplyList,
                  pageSize: pageSizeApplyList,
                }),
              onChange: applyListcurrentChange,
            }"
          >
            <a-table-column :width="100" title="序号" dataIndex="id">
              <template slot-scope="id, applyTableData, index">
                {{ index + 1 + (currentApplyList - 1) * 5 }}
              </template>
            </a-table-column>
            <a-table-column
              :width="100"
              title="条件名称"
              :ellipsis="true"
              dataIndex="attachmentCondition"
            >
            </a-table-column>
            <a-table-column
              :ellipsis="true"
              :width="150"
              title="条件说明"
              dataIndex="attachmentIntro"
            >
            </a-table-column>
            <a-table-column
              :ellipsis="true"
              :width="150"
              title="附件"
              dataIndex="attachmentUrl"
            >
            </a-table-column>
            <a-table-column :width="150" title="操作" dataIndex="operation">
              <template slot-scope="id, applyTableData">
                <a @click="() => btnApplyEdit(applyTableData.id)">编辑</a>
                <div class="border"></div>
                <a-popconfirm
                  title="确定删除?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="btnApplyDelect(applyTableData.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </template>
            </a-table-column>
          </a-table>
        </div>
      </div>
    </a-modal>
    <a-modal width="800px" v-model="QAMODEL" title="帮助问答" @ok="QAModelOk">
      <div class="tableBox">
        <div class="header">
          <div class="ser">帮助问答</div>
          <div class="ser">
            <a-button @click="btnAddQAList" type="primary"> 添加 </a-button>
          </div>
        </div>
        <div class="content">
          <a-table
            :data-source="QATableData"
            :pagination="{
              total: totalQAList,
              pageSize: pageSizeQAList,
              current: currentQAList,
              showTotal: (total) =>
                $t('public.page', {
                  total: totalQAList,
                  pageSize: pageSizeQAList,
                }),
              onChange: QAListcurrentChange,
            }"
          >
            <a-table-column :width="100" title="序号" dataIndex="id">
              <template slot-scope="id, applyTableData, index">
                {{ index + 1 + (currentQAList - 1) * 5 }}
              </template>
            </a-table-column>
            <a-table-column title="问题" :ellipsis="true" dataIndex="title">
            </a-table-column>
            <a-table-column :ellipsis="true" title="答案" dataIndex="answer">
            </a-table-column>
            <a-table-column :width="150" title="操作" dataIndex="operation">
              <template slot-scope="id, applyTableData">
                <a @click="() => btnQAEdit(applyTableData.id)">编辑</a>
                <div class="border"></div>
                <a-popconfirm
                  title="确定删除?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="btnQADelect(applyTableData.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </template>
            </a-table-column>
          </a-table>
        </div>
      </div>
    </a-modal>
    <a-modal :width='600' v-model="modalVisible" title="添加基金" @ok="handleOkAddList">
      <a-form
        :form="modelForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
        @submit="handleSubmit"
      >
        <a-form-item label="基金类型">
          <a-select
            placeholder="选择基金类型"
            v-decorator="[
              'fundType',
              {
                rules: [{ required: true, message: '请输入基金类型' }],
              },
            ]"
          >
            <a-select-option
              v-for="(item, index) in fundTypeData"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="名称">
          <a-input
            v-decorator="[
              'fundName',
              {
                rules: [{ required: true, message: '请输入基金名称' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="网址">
          <a-input
            v-decorator="[
              'enrollUrl',
              {
                rules: [{ required: true, message: '请输入网址' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="概述">
          <a-input
            type="textarea"
            v-decorator="[
              'fundUnit',
              {
                rules: [{ required: true, message: '请输入概述' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="介绍">
          <a-input
            type="textarea"
            v-decorator="[
              'enrollIntro',
              {
                rules: [{ required: true, message: '请输入介绍' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="封面">
          <a-upload
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            accept="image/*"
            :beforeUpload="beforeUpload"
            :action="null"
            v-decorator="[
              'fundImg',
              {
                rules: [{ required: true, message: '请添加图片' }],
              },
            ]"
          >
            <img
              style="width: 100px; height: 100px"
              v-if="fundImg"
              :src="fundImg"
              alt="avatar"
            />
            <div v-else>
              <a-icon :type="ImgLoading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 19 }" label="基金申请条件">
          <div style="width: 100%" id="matchCondition">
            <editor-bar
              v-model="matchConditionContent"
              @change="changeCondition"
            ></editor-bar>
          </div>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 19 }" label="基金申请流程">
          <div style="width: 100%" id="matchProgress">
            <editor-bar
              v-model="matchProgressContent"
              @change="changeProgress"
            ></editor-bar>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal v-model="ApplyModelShow" title="添加申请条件" @ok="AddApplyListOk">
      <a-form
        :form="addApplyListForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
        @submit="handleSubmitAddApplyList"
      >
        <a-form-item label="条件名称">
          <a-input
            v-decorator="[
              'attachmentCondition',
              {
                rules: [{ required: true, message: '请输入条件名称' }],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="条件说明">
          <a-input
            type="textarea"
            v-decorator="[
              'attachmentIntro',
              {
                rules: [{ required: true, message: '请输入条件说明' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="附件">
          <a-upload
            v-decorator="[
              'attachmentUrl',
              {
                rules: [{ required: true, message: '请添加附件' }],
              },
            ]"
            :action="null"
            :multiple="false"
            :file-list="fileList"
            :beforeUpload="beforeUploadApplyFile"
          >
            <a-button> <a-icon type="upload" /> Upload </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal v-model="QAModelShow" title="添加问题" @ok="AddQAModelOk">
      <a-form
        :form="addQAForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
        @submit="handleSubmitQAList"
      >
        <a-form-item label="问题">
          <a-input
            type="textarea"
            v-decorator="[
              'title',
              {
                rules: [{ required: true, message: '请输入问题' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="答案">
          <a-input
            type="textarea"
            v-decorator="[
              'answer',
              {
                rules: [{ required: true, message: '请输入答案' }],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import E from 'wangeditor'
import EditorBar from '../../components/wangEnduit'
import { mapGetters } from 'vuex'
import aliOSS from 'ali-oss'
import utils from '../../utils/index.js'
import { setTimeout } from 'timers'
export default {
  data() {
    return {
      matchProgressContent: '',
      matchConditionContent: '',
      QAModelShow: false,
      switchData: [
        { name: '所有基金', id: 0 },
        { name: '主流基金', id: 1 },
        { name: '校内基金', id: 2 },
        { name: '其他基金', id: 3 },
      ],
      tableLoading: false,
      dataSource: [],
      selectedRowKeys: [],
      total: 0,
      current: 1,
      // aliOSS实例
      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this, { name: 'coordinated' }),
      addQAForm: this.$form.createForm(this, { name: 'addQAForm' }),
      modelForm: this.$form.createForm(this, { name: 'modelForm' }),
      addApplyListForm: this.$form.createForm(this, {
        name: 'addApplyListForm',
      }),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 },
      },
      uploadLoading: false,
      searchValue: '',
      pageSize: 20,
      total: 0,
      current: 1,
      fundAllListData: [],
      approvalList: [],
      fundAllListLoading: true,
      formLayout: 'horizontal',
      ImgLoading: false,
      fundImg: '',
      fundType: 0,
      fundTypeData: [
        {
          id: 1,
          name: '主流基金',
        },
        {
          id: 2,
          name: '校内基金',
        },
        {
          id: 3,
          name: '其他基金',
        },
      ],
      // 1为编辑2为添加基金
      selectFlag: null,
      EditId: null,
      applyMode: false,
      applyTableData: [],
      pageSizeApplyList: 5,
      totalApplyList: 0,
      currentApplyList: 1,
      ApplyModelShow: false,
      uploadSuccess: require('../../assets/img/uploadSuccess.png'),
      fileUploadSuccess: false,
      fileList: [],
      attachmentUrl: '',
      fundId: '',
      applyId: '',
      applyEditListFlag: '',
      totalQAList: 0,
      pageSizeQAList: 5,
      currentQAList: 1,
      QAMODEL: false,
      QATableData: [],
      QAEditListFlag: null,
    }
  },

  props: {
    updateComponent: {
      type: String,
      default: '',
    },
  },
  watch: {
    updateComponent() {
      this.handleSearch()
    },
    searchValue(val) {
      console.log(val)
      this.current = 1
      this.getFundData(this.fundType, val)
    },
  },

  created() {
    this.getFundData(this.fundType, '')
  },
  components: { EditorBar },
  methods: {
    btnDetail(id) {
      this.$router.push({ name: 'fundMember', params: { id } })
    },
    changeProgress(val) {
      this.matchProgressContent = val
    },
    changeCondition(val) {
      this.matchConditionContent = val
    },
    btnopenfile(url) {
      window.open(url)
    },
    btnQAEdit(id) {
      this.QAEditListFlag = 1
      this.QAItemId = id
      this.QAModelShow = true
      let itemData = this.QATableData.find((Element) => {
        return id == Element.id
      })
      console.log(itemData)
      this.$nextTick(() => {
        this.addQAForm.setFieldsValue({
          answer: itemData.answer,
          title: itemData.title,
        })
      })
    },
    btnQADelect(id) {
      let data = {
        id,
      }
      this.$http(this.$api.DELETEQALISTITEM, data).then((r) => {
        console.log(r)
        this.btnSeeDetail()
        this.$notification.open({
          type: 'success',
          message: '删除问题',
          description: '删除成功',
        })
      })
    },
    handleSubmitQAList() {
      this.addQAForm.validateFields((err, data) => {
        if (!err) {
          //申请条件编辑
          if (this.QAEditListFlag == 1) {
            data.id = this.QAItemId
            this.$http(this.$api.UPDATEQALISTITEM, data).then((r) => {
              console.log(r)
              this.addQAForm.resetFields()
              this.QAModelShow = false
              this.btnSeeDetail()
              this.$notification.open({
                type: 'success',
                message: '修改申请条件',
                description: '修改成功',
              })
            })
          } else if (this.QAEditListFlag == 2) {
           
            this.$http(this.$api.ADDQALISTITEM, data).then((r) => {
              console.log(r)
              this.btnSeeDetail()
              this.addQAForm.resetFields()
              this.btnSeeDetail(this.fundName)
              this.QAModelShow = false
              this.$notification.open({
                type: 'success',
                message: '添加申请条件',
                description: '添加成功',
              })
            })
          }
        }
      })
    },
    AddQAModelOk() {
      this.handleSubmitQAList()
    },

    QAListcurrentChange(val) {
      console.log(val)
      this.currentQAList = val
      this.btnSeeDetail()
    },
    btnSeeDetail() {
      this.QAMODEL = true
      console.log('btnSeeDetail')
      let data = {
        title: '',
        pageNum: this.currentQAList,
        pageSize: this.pageSizeQAList,
      }
      // this.QAModelShow = true;
      this.$http(this.$api.GTEQALISTDATA, data).then((r) => {
        console.log(r)
        this.QATableData = r.data.records
        this.totalQAList = r.data.total
        this.$nextTick(() => {})
      })
    },
    btnAddQAList(id) {
      console.log('btnAddQAList')
      this.QAEditListFlag = 2
      this.QAModelShow = true
    },
    QAModelOk() {
      console.log('QAModelOk')
    },
    applyListcurrentChange(val) {
      console.log(val)
      // this.currentApplyList
      this.currentApplyList = val
      this.btnApplyDetail(this.fundId)
    },
    handleSubmitAddApplyList() {
      this.addApplyListForm.validateFields((err, data) => {
        if (!err) {
          //申请条件编辑
          let addApplyList = data
          addApplyList.attachmentUrl = this.attachmentUrl
          addApplyList.fundId = this.fundId
          addApplyList.id = this.applyId
          console.log(addApplyList)
          if (this.applyEditListFlag == 1) {
            this.$http(this.$api.UPDATEAPPLYLIST, data).then((r) => {
              console.log(r)
              this.addApplyListForm.resetFields()
              this.btnApplyDetail(this.fundId)
              this.ApplyModelShow = false
              this.$notification.open({
                type: 'success',
                message: '修改申请条件',
                description: '修改成功',
              })
            })
          } else if (this.applyEditListFlag == 2) {
            //申请条件添加
            this.$http(this.$api.ADDAPPLYLIST, data).then((r) => {
              console.log(r)
              this.addApplyListForm.resetFields()
              this.btnApplyDetail(this.fundId)
              this.fileList = []
              this.ApplyModelShow = false
              this.$notification.open({
                type: 'success',
                message: '添加申请条件',
                description: '添加成功',
              })
            })
          }
        }
      })
    },
    beforeUploadApplyFile(file) {
      console.log(file)
      this.uploadHeader = true
      let currentTime = new Date().getTime()
      let filename = file.name
      let showFilename = file.name
      filename =
        filename.split('.')[0] + currentTime + '.' + filename.split('.')[1]
      let AliyunUpload = utils.AliyunUpload(this.$config, filename, file)
      AliyunUpload.then((r) => {
        console.log(r.res.requestUrls[0])
        this.attachmentUrl = r.res.requestUrls[0]
        this.fileList = [
          {
            uid: '-1',
            name: showFilename,
            status: 'done',
            url: r.res.requestUrls[0],
          },
        ]
        this.fileUploadSuccess = true
      })
      return false //阻止upload框架自动上传
    },
    AddApplyListOk() {
      this.handleSubmitAddApplyList()
    },
    //申请条件添加按钮
    btnAddApplyList() {
      this.applyEditListFlag = 2
      this.ApplyModelShow = true
      this.addApplyListForm.resetFields()
      this.fileList = []
    },
    btnApplyEdit(id) {
      console.log(id)
      this.applyId = id
      this.applyEditListFlag = 1
      let findApplyData = this.applyTableData.find((Element) => {
        return Element.id == id
      })
      console.log(findApplyData)
      this.ApplyModelShow = true
      this.attachmentUrl = findApplyData.attachmentUrl
      this.$nextTick(() => {
        this.addApplyListForm.setFieldsValue({
          attachmentCondition: findApplyData.attachmentCondition,
          attachmentUrl: findApplyData.attachmentUrl,
          attachmentIntro: findApplyData.attachmentIntro,
        })
        this.fileList = [
          {
            uid: '-1',
            name: findApplyData.attachmentCondition,
            status: 'done',
            url: findApplyData.attachmentUrl,
          },
        ]
      })

      // this.handleSubmitAddApplyList
    },
    btnApplyDelect(id) {
      console.log(id)
      let data = {
        id,
      }
      this.$http(this.$api.DELECTAPPLYLIST, data).then((r) => {
        this.$nextTick(() => {
          this.btnApplyDetail(this.fundId)
          this.$notification.open({
            type: 'success',
            message: '删除申请条件',
            description: '删除成功',
          })
        })
      })
    },
    //查看详情
    btnApplyDetail(id) {
      console.log(id)
      this.fundId = id
      this.applyMode = true
      let data = {
        id,
        pageSize: this.pageSizeApplyList,
        pageNum: this.currentApplyList,
      }
      this.$http(this.$api.QUERYFUNDAPPLYDATA, data).then((r) => {
        console.log(r)
        this.$nextTick(() => {
          this.applyTableData = r.data.records
          this.totalApplyList = r.data.total
        })
      })
    },
    //获取基金数据
    getFundData(fundType, fundName) {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.current,
        fundType: parseInt(fundType),
        fundName: fundName,
      }
      this.$http(this.$api.GETFUNDDATA, data).then((r) => {
        this.fundAllListData = r.data.records
        this.fundAllListLoading = false
        this.total = r.data.total
      })
    },
    btnEdit(id) {
      this.selectFlag = 1
      this.modalVisible = true
      this.queryFundId(id)
    },
    btnDelect(id) {
      let data = {
        id,
      }
      this.fundAllListLoading = true
      this.$http(this.$api.DELECTFUNDSDATA, data).then((r) => {
        this.getFundData(this.fundType, '')
        this.$notification.open({
          type: 'success',
          message: '删除基金',
          description: '基金删除成功',
        })
      })
    },
    queryFundId(id) {
      //  console.log(this.fundAllListData)
      let queryFundIdData = this.fundAllListData.find((Element) => {
        return id == Element.id
      })
      //  this.form = queryFundIdData
      console.log(queryFundIdData)
       this.matchConditionContent = queryFundIdData.fundCondition
      this.matchProgressContent = queryFundIdData.fundProgress
      this.$nextTick(() => {
        this.modelForm.setFieldsValue({
          fundType: queryFundIdData.fundType,
          fundName: queryFundIdData.fundName,
          enrollUrl: queryFundIdData.enrollUrl,
          fundUnit: queryFundIdData.fundUnit,
          enrollIntro: queryFundIdData.enrollIntro,
          fundImg: queryFundIdData.fundImg,
        })
        this.EditId = id
        this.fundImg = queryFundIdData.fundImg
        this.getFundData(this.fundType, '')
      })
    },
    beforeUpload(file) {
      this.uploadHeader = true
      let currentTime = new Date().getTime()
      let filename = file.name
      filename =
        filename.split('.')[0] + currentTime + '.' + filename.split('.')[1]
      let AliyunUpload = utils.AliyunUpload(this.$config, filename, file)
      AliyunUpload.then((r) => {
        this.fundImg = r.res.requestUrls[0]
      })
      return false //阻止upload框架自动上传
    },
    changeTab(key) {
      // console.log(key)
      this.fundAllListLoading = true
      this.getFundData(key, '')
    },
    // 添加基金
    showModalAddList() {
      // this.modelForm.setFieldsValue({})
      this.fundImg = ''
      this.modelForm.resetFields()
      this.selectFlag = 2
      this.modalVisible = true
    },
    handleOkAddList() {
      this.handleSubmit()
    },

    // 分页
    currentChange(val) {
      this.current = val
      this.getFundData(this.fundType, '')
    },
    handleSubmit(e) {
      this.modelForm.validateFields((err, data) => {
        if (!err) {
          this.modalVisible = false
          console.log('Received values of form: ', data)
          let addFundData = data
          addFundData.fundImg = this.fundImg
          if (this.selectFlag == 1) {
            data.fundCondition = this.matchConditionContent
            data.fundProgress = this.matchProgressContent
            addFundData.id = parseInt(this.EditId)
            //编辑基金
            this.$http(this.$api.UPDATEFUND, addFundData).then((r) => {
              this.getFundData(this.fundType, '')
              this.$notification.open({
                type: 'success',
                message: '编辑基金',
                description: '基金编辑成功',
              })
            })
          } else if (this.selectFlag == 2) {
                  if (this.matchConditionContent.length == 0) {
              this.$message.error('请填写参赛条件')
              return false
            } else if (this.matchProgressContent.length == 0) {
              this.$message.error('请填写参赛流程')
              return false
            }
            data.fundCondition = this.matchConditionContent
            data.fundProgress = this.matchProgressContent
            this.$http(this.$api.ADDFUNDSDATA, addFundData).then((r) => {
              this.getFundData(this.fundType, '')
              this.$http(this.$api.DELECTFUNDSDATA, data).then((r) => {
                this.$notification.open({
                  type: 'success',
                  message: '添加基金',
                  description: '基金添加成功',
                })
                this.getFundData(this.fundType, '')
              })
            })
          }
        }
      })
    },
    applyModelOk() {
      console.log(12321)
    },
  },
}
</script>
<style scoped lang="less">
.page-content {
  width: 100%;
  height: 100%;
  overflow: scroll;
  .tableItem {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    width: 200px;
  }
  .header {
    width: 100%;
    height: 80px;
    padding: 20px 20px 0 20px;
    box-sizing: border-box;
    .ser {
      float: left;
    }
    .ser:last-child {
      float: right;
    }
  }
  .navList {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
  /deep/ .ant-upload {
    img {
      width: 100px;
      height: 100px;
    }
  }

  /deep/ .ant-table-tbody {
    /deep/ .border {
      position: relative;
      top: -0.06em;
      display: inline-block;
      width: 1px;
      height: 0.9em;
      margin: 0 8px;
      vertical-align: middle;
      background-color: #e8e8e8;
    }
  }
}
/deep/ .ant-modal-body {
  /deep/ .tableBox {
    width: 100%;
    height: 100%;
    .header {
      width: 100%;
      height: 60px;
      .ser {
        float: left;
        width: 50%;
      }
      .ser:last-child {
        .ant-btn {
          float: right;
        }
      }
    }
  }
  /deep/ .border {
    position: relative;
    top: -0.06em;
    display: inline-block;
    width: 1px;
    height: 0.9em;
    margin: 0 8px;
    vertical-align: middle;
    background-color: #e8e8e8;
  }
  /deep/ .ant-upload-list-item-card-actions {
    display: none;
  }
}
</style>
